//settings for form
export class UserSettings {
    constructor() {

    }
    static isDateDisabled = true;
    static dateInputFormat = 'DD-MM-YYYY';
    static BsDatepickerTheme = 'theme-dark-blue';
    static enablePagination = true;
    static disableHeaderForm = true;

    static getCalConfig(){
        return  { "dateInputFormat":this.dateInputFormat, "containerClass": this.BsDatepickerTheme };
    }
}